// Bandera de la app «Ayuda y Tutoriales» (CC-CONSOLE #1431).
//
// La ayuda no se cierra por licencia ni por rol (ver UNGATED_PATHS en
// router/entitlementGates): la lee toda persona con sesión. Lo ÚNICO que la
// cierra es su bandera de Feature Flags: apagada (o «sólo administradores» para
// quien no opera banderas) desaparecen la app, sus tutoriales y la ruta /ayuda.
import type { ReactNode } from "react";
import { useEntitlements } from "../../hooks/useEntitlement";
import EntitlementRoute from "../../router/EntitlementRoute";

/** Nodo del catálogo de la app «Ayuda y Tutoriales». */
export const HELP_APP_KEY = "app:settings";

/** ¿La bandera deja ver la ayuda? Sin respuesta del backend, sí. */
export function useHelpFlagOn(): boolean {
  const reason = useEntitlements().reasonFor(HELP_APP_KEY);
  return reason !== "flag-off" && reason !== "flag-internal";
}

/** Cierra /ayuda cuando la bandera la apaga: manda al Hub con el motivo. */
export function HelpFlagGate({ children }: { children: ReactNode }) {
  return useHelpFlagOn() ? <>{children}</> : <EntitlementRoute entitlement={HELP_APP_KEY} />;
}
